import React from 'react';
import PropTypes from 'prop-types';

import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import * as vignetsActions from "../../actions/vignets";
import * as vignetsReducers from "../../reducers/vignets";
import VignetContainer from "../vignets/VignetContainer";
import 'react-confirm-alert/src/react-confirm-alert.css'
import * as pageReducers from "../../reducers/pages";
import * as galleryReducers from "../../reducers/gallery";
import * as playlistReducers from "../../reducers/playlist";
import * as playlistActions from "../../actions/playlist";

import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap';
import * as userReducers from "../../reducers/user";

class RightContentHeader extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            vignetIds: [],
            showDialog: false,
            showError : false,
            modalOptions : { showHeader : false, showFooter : false , titlepageSettings  : '', id : "galleryModal", content: '' },
            userDet : JSON.parse(window.localStorage.userDet),
            showPl : false,
            showConfirm : false,
            showPlMessage : false,
            addVigToPl : false

        };

        this.renderPageTitle = this.renderPageTitle.bind(this);
        this.plToggle = this.plToggle.bind(this);
        this.mToggle = this.mToggle.bind(this);
        this.toggle = this.toggle.bind(this);
        this.confirmDelete = this.confirmDelete.bind(this);
    }

    componentDidMount() {

        //this.setState({plId: this.props.match.params.id});
        if( this.props.match.path === "/playlist/add/:id") {
            this.setState({ addVigToPl: true});
        }

       // let data = {userid : this.state.userDet.user_id};
        //this.props.allPlaylistData(data);

    }

    deleteItems() {

        if(this.props.vignetsData.selected_ids.length > 0) {
            this.setState({ showConfirm : true, modalOptions : {showModal:this.state.showModal} });

            //this.state.modalOptions.showModal = this.state.showModal;
           /* if(this.props.pageName === 'VIGNETS') {
                this.props.selectedVignets();
                this.props.removeVignets(this.props.vignetsData);
                let data = { userid : this.state.userDet.user_id };
                this.props.allVignetsData(data);

                console.log(this.props.vignetsData);
            }
            else if(this.props.pageName === 'MY_UPLOADS') {
            }
            else if(this.props.pageName === 'AUDIO') {
            }
            else if(this.props.pageName === 'VIDEO') {
            }*/
        }
        else {
            this.setState({showPlMessage : true});
        }



    }

    showMyPlaylists(e) {

        if(this.props.vignetsData.selected_ids.length > 0) {

            if(this.props.pageName === 'VIGNETS') {
                this.setState({ showPl : true, modalOptions : {showModal:this.state.showModal} });

                console.log(this.state.showPl);

            }
        }
        else {
            this.setState({showPlMessage : true});
        }

    }

    addToPlaylist(plid) {
        let data = {plid : plid, vigids : this.props.vignetsData.selected_ids}
        let added = this.props.addItemToPlaylist(data);

        if(added){
            this.plToggle();
        }


       // $("#plModal").({'data-dismiss': 'modal'});
    }

    renderPageTitle() {
        switch(this.props.pageName) {
            case 'OVERVIEW':
                return 'Overview';
            case 'VIGNETS':
                return 'Vignets';
            case 'MY_UPLOADS':
                return 'Gallery';
            case 'AUDIO':
                return 'Audio';
            case 'VIDEO':
                return 'Video';
            case 'PLAYLIST':
                return 'Playlist';
            case 'PLAYLISTDETAIL':
                return 'Playlist';
            case 'USER':
                return 'User';
            default:
                return 'Vignets';
        }
    }

    renderItemCount() {

        switch(this.props.pageName) {
            case 'VIGNETS':
                return this.props.vignetsData.vignetCount;
            case 'MY_UPLOADS':
                return this.props.galleryData.galleryCount;
            case 'AUDIO':
                return this.props.galleryData.galleryCount;
            case 'VIDEO':
                return this.props.galleryData.galleryCount;
            case 'PLAYLIST':
                return this.props.playlistData.playlistCount;
            case 'USER':
                return this.props.userListData.userListCount;
            default:
                return this.props.vignetsData.vignetCount;
        }
    }

    plToggle() {
        console.log(this.state.showPl);
        this.setState({
            showPl: !this.state.showPl
        });
    }

    confirmDelete() {
        //this.props.selectedVignets();
        this.props.removeVignets(this.props.vignetsData.selected_ids);
        this.setState({ showConfirm :false });
    }

    toggle() {
        this.setState({
            showConfirm: !this.state.showConfirm
        });
    }
    mToggle() {
        console.log(this.state.showPlMessage);
        this.setState({
            showPlMessage: !this.state.showPlMessage
        });
    }
    backToPlaylists() {
        this.props.backToPlaylists();
    }
    render() {

       // let playListData = this.props.playlistData?this.props.playlistData.playListItems:null;



        return (

            <div className="right-top-header">
                <div className="right-top-header-wrap">
                    <div className="page-title">
                        <h1 className="subheader">{this.renderPageTitle()} {this.props.pageName !== 'VIGDETAIL' &&  this.props.pageName !== 'OVERVIEW' && this.props.pageName !== 'PLAYLISTDETAIL' &&  '('+this.renderItemCount()+')'}</h1>
                    </div>

                    {!this.state.addVigToPl  &&
                        <div className="header-option-block">
                            {this.props.pageName === 'VIGNETS' &&
                            <ul className="header-option-list">

                                <li>
                                    <a href="javascript:void(0);" className="header-option icon-lib delete-ico"
                                       data-toggle="modal" data-target="#delete-vignets"
                                       onClick={() => {
                                           this.deleteItems()
                                       }}>Delete</a>
                                </li>
                                {/*<li>
                                    <a href="javascript:void(0);" data-toggle="modal" data-target="#plModal"
                                       className="header-option icon-lib addto-ico" onClick={(e) => {
                                        this.showMyPlaylists(e)
                                    }}>Add to</a>
                                </li>

                                <li>
                                    <a href="javascript:void(0);" className="header-option icon-lib share-ico">Share</a>
                                </li>*/}
                            </ul>
                            }
                            {this.props.pageName === 'PLAYLISTDETAIL' &&
                            <button type="button" className="btn btn-secondary"
                                    onClick={() => this.backToPlaylists()}>Back To Playlists</button>
                            }
                        </div>
                    }


                </div>
                {/*
                    this.state.showDialog &&
                    <ReactConfirmAlert
                        title="Confirm "
                        message="Are you sure to delete the vignets?"
                        confirmLabel="Confirm"
                        cancelLabel="Cancel"
                        onConfirm={() => this.confirmDelete()}
                        onCancel={() => alert('Action after Cancel')}
                    />
                */}

                {this.state.showConfirm &&

                <Modal isOpen={this.state.showConfirm} id="delete-vignets">
                    <ModalBody>
                        <div className="alert alert-default text-center" role="alert">
                            Are you sure to delete the vignets?
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.toggle}>Cancel</Button>
                        <Button color="primary" onClick={this.confirmDelete}>Confirm</Button>
                    </ModalFooter>
                </Modal>
                }

                {this.state.showPlMessage &&

                <Modal isOpen={this.state.showPlMessage} id="pl-message">
                    <ModalBody>
                        <div className="alert alert-default text-center" role="alert">
                            No vignets have been selected
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.mToggle}>Close</Button>
                    </ModalFooter>
                </Modal>
                }

                {/*<Modal isOpen={this.state.showPl} toggle={this.plToggle} centered={true} className="vig-mod">
                    <ModalHeader className="vignet-header">Add to playlist</ModalHeader>
                    <ModalBody className="fixed-scroll">
                        <div>
                        <ul className="playlist-collection">
                            {playListData &&

                            playListData.map((entry, index) => <li onClick={() => {this.addToPlaylist(entry.pl_id)}}>{entry.pl_name}</li>
                            )
                            }
                        </ul>
                        </div>
                    </ModalBody>
                </Modal>*/}
            </div>

        );
    }
}


RightContentHeader.propTypes = {
    pageName: PropTypes.string
}



function mapStateToProps(state) {
    return {
        vignetsData  :vignetsReducers.getVignetsData(state),
        galleryData  :galleryReducers.getGalleryData(state),
        playlistData  :playlistReducers.getPlaylistData(state),
        userListData  :userReducers.getUserData(state),
        pageInfo  :pageReducers.getPageSettings(state)
    };

}

export default  withRouter(connect(mapStateToProps, {
    selectedVignets : vignetsActions.vignetsSelected,
    removeVignets : vignetsActions.deleteVignets,
    allVignetsData : vignetsActions.vignetsData,
    addItemToPlaylist : playlistActions.addToPlaylist,
    allPlaylistData : playlistActions.getPlayLists,
    removeSelection : vignetsActions.removeSelection,
    backToPlaylists : playlistActions.resetPlaylistDetail
})(RightContentHeader, VignetContainer));



// WEBPACK FOOTER //
// ./src/components/common/RightContentHeader.js